<template>
  <div class="title-container">
    <fadeInAnimation>
      <div class="part-name">{{ partName }}</div>
    </fadeInAnimation>
    <div class="title-content">
      <springText class="item-title" :text="title"></springText>
    </div>
    <fadeInAnimation>
      <div class="sub-title">
        <slot></slot>
      </div>
    </fadeInAnimation>
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";
import springText from "@/views/components/springText";
import fadeInAnimation from "@/views/components/fadeInAnimation";

export default {
  mixins: [responsiveMixin],
  components: { springText, fadeInAnimation },
  props: {
    title: {
      type: String,
      default: ""
    },
    partName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  mounted() { },
  methods: {},
  watch: {},
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>